import React from 'react'

const Footer = () => {
  return (
    <div className='classfooter text-center'>
      <a href='#'>Terms and services</a>&nbsp; | &nbsp;
      <a href='#'>Privacy and policy</a>
       
    <p>© 2025 iNotebook. All rights reserved.</p>

    </div>
  )
}

export default Footer
